export default {
    routerName: 'ロール管理',
    role: {
        searchName: '検索条件',
        name: 'ロール名',
        code: 'コード',
        sortOrder: 'ソート',
        authority: '権限',
        createTime: '作成日付',
        createStartTime: '作成開始日付',
        createEndTime: '作成終了日付',
        status: '状態',
        open: '有効',
        close: '無効',
    },
    table: {
        id: 'ID',
        name: 'ロール名',
        code: 'コード',
        sortOrder: 'ソート',
        createBy: '作成者',
        createTime: '作成日付',
        status: '状態',
    },
};
